import { all, put, takeEvery, fork } from "redux-saga/effects";
import { apiURL } from "../actions/helpers";
import axios from "axios";

// Action Types
export const LIVE_ALERTS_LOAD = "LIVE_ALERTS/LOAD";
export const LIVE_ALERTS_LOAD_SUCCESS = "LIVE_ALERTS/LOAD/SUCCESS";
export const LIVE_ALERTS_LOAD_FAILURE = "LIVE_ALERTS/LOAD/FAILURE";

// Action Creators
export const liveAlertsLoad = () => ({
  type: LIVE_ALERTS_LOAD,
});

export const liveAlertsLoadSuccess = (data) => ({
  type: LIVE_ALERTS_LOAD_SUCCESS,
  data,
});

export const liveAlertsLoadFailure = (error) => ({
  type: LIVE_ALERTS_LOAD_FAILURE,
  error,
});

// Sagas
function* fetchLiveAlerts() {
  try {
    const response = yield axios.get(`${apiURL}/ai-alerts/live`, {
      withCredentials: true,
    });
    yield put(liveAlertsLoadSuccess(response.data?.alertGroups || []));
  } catch (error) {
    yield put(liveAlertsLoadFailure(error));
  }
}

function* listenLiveAlertsLoad() {
  yield takeEvery(LIVE_ALERTS_LOAD, fetchLiveAlerts);
}

// Root Saga
export function* saga() {
  yield all([fork(listenLiveAlertsLoad)]);
}

// Initial State
const INIT_STATE = {
  alertGroups: [],
  loading: false,
  error: null,
};

// Reducer
const reducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case LIVE_ALERTS_LOAD:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case LIVE_ALERTS_LOAD_SUCCESS:
      return {
        ...state,
        alertGroups: action.data,
        loading: false,
        error: null,
      };
    case LIVE_ALERTS_LOAD_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    default:
      return state;
  }
};

// Selectors
export const getLiveAlertsData = (state) => state.liveAlerts.alertGroups;
export const getLiveAlertsLoading = (state) => state.liveAlerts.loading;

export default reducer;
